import { render, staticRenderFns } from "./GeralCurso.vue?vue&type=template&id=f3ba9b32&"
import script from "./GeralCurso.vue?vue&type=script&lang=js&"
export * from "./GeralCurso.vue?vue&type=script&lang=js&"
import style0 from "./GeralCurso.vue?vue&type=style&index=0&id=f3ba9b32&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports